"use client";
import { DecrementButton, Field, IncrementButton, InputNumber, InputNumberDecrementButton, InputNumberField, InputNumberIncrementButton, Root, createInputNumberScope } from "./input-number.js";
export { DecrementButton, Field, IncrementButton, InputNumber, InputNumberDecrementButton, InputNumberField, InputNumberIncrementButton, Root, createInputNumberScope };
